export {default as sendIcon} from './send-icon.svg';
export {default as unclickableSendIcon} from './unclickable-send-icon.svg'
export {default as micIcon} from './mic-icon.svg';
export {default as speakerIcon} from './speaker-icon.svg';
export {default as userIcon} from './users-icon.svg';
export {default as botIcon} from './bot-icon.svg';
export {default as activeSpeakerIcon} from './active-speaker-icon.svg'